import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { NtaFacilityStore } from './facility.store';

export const facilityAdminGuard = () => {
	const store = inject(NtaFacilityStore);
	const router = inject(Router);

	return toObservable(store.facilityLoaded).pipe(
		filter((loaded) => loaded),
		map(() => {
			if (!store.isAdmin()) {
				router.navigate(['']);
			}
			return store.isAdmin();
		})
	);
};
